import { Box, Stack, Typography, styled } from '@mui/material';

export const ReleaseContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  padding: theme.spacing(3, 3),
  height: '100%',
  overflowY: 'scroll',
  [theme.breakpoints.down('sm')]: {
    overflowY: 'hidden',
  },
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(2, 3),
  },
}));

export const StyledHeaderContainer = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  width: '100%',
  justifyContent: 'space-between',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    justifyContent: 'flex-start',
    gap: theme.spacing(2),
  },
}));

export const Header = styled(Typography)(({ theme }) => ({
  fontSize: 32,
  height: theme.spacing(6),
}));
